import { useState } from "react";

const useRejectModal = ({ onReject, showSnackbar }) => {
    const [isProcessing, setIsProcessing] = useState(false);
    const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
    const [itemsToReject, setItemsToReject] = useState(null);
    const [itemInfo, setItemInfo] = useState({ name: null, count: null });

    const openRejectModal = (items, itemName = null) => {
        const itemsArray = Array.isArray(items) ? items : [items];
        setItemsToReject(itemsArray);
        setItemInfo({
            name: itemName || (itemsArray.length === 1 ? itemsArray[0]?.storeName || itemsArray[0]?.name || null : null),
            count: itemsArray.length,
        });
        setRejectDialogOpen(true);
    };

    const closeRejectModal = () => {
        setRejectDialogOpen(false);
        setItemsToReject(null);
        setItemInfo({ name: null, count: null });
        setIsProcessing(false);
    };

    const handleRejectConfirm = async (reason) => {
        if (isProcessing) return;

        if (!reason?.trim()) {
            if (showSnackbar) {
                showSnackbar({
                    open: true,
                    message: "Please provide a rejection reason",
                    severity: "warning",
                });
            }
            return;
        }

        setIsProcessing(true);

        try {
            const ids = itemsToReject.map(item => item._id);
            await onReject(ids, reason);

            if (showSnackbar) {
                const count = itemsToReject.length;
                showSnackbar({
                    open: true,
                    message: `${count} item${count > 1 ? "s" : ""} rejected successfully`,
                    severity: "success",
                });
            }

            closeRejectModal();
            return { success: true, items: itemsToReject };
        } catch (error) {
            console.error("Error rejecting item:", error);
            if (showSnackbar) {
                showSnackbar({
                    open: true,
                    message: error.message || "Failed to reject item",
                    severity: "error",
                });
            }
            setIsProcessing(false);
            return { success: false, error: error.message };
        }
    };

    return {
        isProcessing,
        rejectDialogOpen,
        itemsToReject,
        itemInfo,
        openRejectModal,
        closeRejectModal,
        handleRejectConfirm,
    };
};

export default useRejectModal;